import "#webapp/src/components/slack-channel-picker/SlackChannelPicker.gql";
import { graphql } from "react-relay";

export const teamSettingsAdminSlackFragments = {
  org: graphql`
    fragment TeamSettingsAdminSlack_org on Org @argumentDefinitions(teamId: { type: "String!" }) {
      ...SlackChannelPicker_org @arguments(teamId: $teamId)
      id
      experiments
      teamSettings(teamId: $teamId) {
        __typename
        ... on TeamSettings {
          manageTeamCalendar
          slackSettings {
            notificationEnabled
            channelId
            channelName
            timeSlot
          }
        }
        ... on GraphEntityError {
          statusCode
          message
        }
      }
      slackAccountForTeamErrorable(teamId: $teamId) {
        __typename
        ... on GraphEntityError {
          message
          statusCode
        }
        ... on SlackAccount {
          slackUserId
          slackTeamId
          teamDisplayName
          needsUpdate
        }
      }
      publicChannelsForSlackForTeam(teamId: $teamId) {
        __typename
        ... on GraphEntityError {
          statusCode
          message
        }
        ... on SlackChannelList {
          list {
            channelId
            name
          }
        }
      }
    }
  `,
  team: graphql`
    fragment TeamSettingsAdminSlack_team on Team {
      id
      teamId
      teamName
      teamCalendarId
    }
  `,
};

export const refetchQuery = graphql`
  query TeamSettingsAdminSlackQuery($orgRelayId: ID!, $teamId: String!) {
    orgRefetch: node(id: $orgRelayId) {
      ... on Org {
        ...TeamSettingsAdminSlack_org @arguments(teamId: $teamId)
      }
    }
  }
`;
